const textSubmissionDrawerSelectors = {
    expandedQuestionIds: state => state.textSubmissionDrawer.expandedQuestionIds,
    isQuestionExpanded: questionId => state => state.textSubmissionDrawer.expandedQuestionIds.includes(questionId),
    focusedQuestionId: state => state.textSubmissionDrawer.focusedQuestionId,
    focusedQuestionIsExpanded: state =>
        state.textSubmissionDrawer.expandedQuestionIds.includes(state.textSubmissionDrawer.focusedQuestionId),
    activeSectionKey: state => state.textSubmissionDrawer.activeSectionKey,
    gradingMode: state => state.textSubmissionDrawer.gradingMode,
    viewMode: state => state.textSubmissionDrawer.viewMode,
}

export default textSubmissionDrawerSelectors
